export class StringUtils {
  /**
   * Capitalize first letter
   * @param s string to be capitalized
   * @returns captalized string
   */
  static capitalize(s: string) {
    return s
      .split(/\s+/)
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ')
  }

  static cleanHtmlString(string: string) {
    return string.replace(/(<([^>]+)>)/gi, '').trim()
  }
}
